<template>
	<div v-show="show" class="logIn">
		<form class="logIn__form" action="">
			<img @click="$emit('changeShow', false)" class="logIn__close" src="/static/img/close-button.svg" alt="">
			<h2 v-if="!reset" class="logIn__headline">{{$t('logIn.header')}}</h2>
			<h2 v-if="reset" class="logIn__headline">{{$t('reset.header')}}</h2>
			<input class="logIn__input logIn__input--email" type="text" :placeholder="$t('logIn.mail')">
			<span v-if="error.email" class="logIn__error">{{ error.email }}</span>
			<input v-if="!reset" class="logIn__input logIn__input--password" type="password" :placeholder="$t('logIn.password')">
			<span v-if="error.password" class="logIn__error">{{ error.password }}</span>
			<span v-if="error.main" class="logIn__error">Nieprawidłowe dane lub konto nieaktywne</span>
			<!--<label class="logIn__label">-->
				<!--<input class="" type="checkbox">-->
				<!--<span class="logIn__checkbox">-->
						<!--<span class="logIn__checkbox&#45;&#45;bg"></span>-->
				<!--</span>-->
				<!--Keep me signed in-->
			<!--</label>-->
			<button v-if="!reset" class="logIn__btn" @click="logIn($event)">{{$t('logIn.signIn')}}</button>
			<button v-if="reset" class="logIn__btn" @click="resetPassword($event)">{{$t('reset.button')}}</button>
			<span v-if="!reset" class="logIn__or">{{$t('logIn.or')}}</span>
			<router-link v-if="!reset" @click.native="$emit('changeShow', false)" :to="{name: 'CreateAccount'}" class="logIn__btn logIn__btn--flex">{{$t('logIn.create')}}</router-link>
			<span v-if="!reset" @click="reset = true" class="logIn__password">{{$t('logIn.forgotten')}}</span>
			<span v-if="reset" @click="reset = false" class="logIn__password logIn__password--cancel">{{$t('reset.cancel')}}</span>
		</form>
	</div>
</template>

<script>
	import axios from 'axios'
	import router from '@/router'

	export default {
		props: ['show'],
		data () {
			return {
				reset: false,
				error: {
					main: false,
					email: '',
					password: ''
				}
			}
		},
		methods: {
			logIn (event) {
				event.preventDefault()
				this.error.email = ''
				this.error.password = ''
				this.error.main = false
				const email = document.querySelector('.logIn__input--email').value
				const password = document.querySelector('.logIn__input--password').value
				let data = {
					password,
					email
				}
				axios.post('/api/user/login/', data, {
					headers: {
						'accept': 'application/json'
					}
				})
					.then(response => {
						window.localStorage.setItem('token', 'Token ' + response.data.token)
						this.$store.commit('userLogIn')
						this.$emit('changeShow', false)
						if (router.history.current.name === 'Activate' || router.history.current.name === 'ResetPassword') {
							router.push('/')
						}
					})
					.catch(error => {
						if (error.response.status === 401) {
							this.error.main = error.response.data.detail
						}
						if (error.response.status === 400) {
							if (error.response.data.email) {
								this.error.email = error.response.data.email[0]
							}
							if (error.response.data.password) {
								this.error.password = error.response.data.password[0]
							}
						}
					})
			},
			resetPassword (event) {
				event.preventDefault()
				const email = document.querySelector('.logIn__input--email').value
				let data = {
					email
				}
				axios.post('/api/user/reset-password/', data, {
					headers: {
						'accept': 'application/json'
					}
				})
					.then(response => {
						this.$emit('changeShow', false)
						router.push('/reset-password/')
					})
			}
		}
	}
</script>

<style lang="scss">
	@import "../styles/variables.scss";

	.logIn {
		padding-top: 25px;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(243, 235, 212, .83);
		&__form {
			position: relative;
			padding: 65px 95px 40px;
			margin: 0 auto;
			width: 100%;
			max-width: 485px;
			background-color: $gold;
		}
		&__close {
			cursor: pointer;
			position: absolute;
			top: 35px;
			right: 35px;
		}
		&__headline {
			font-family: $lato-bold;
			font-size: 36px;
			color: $black;
			margin: 0;
			margin-bottom: 35px;
		}
		&__input {
			font-family: $lato;
			font-size: 16px;
			color: $black;
			padding: 0;
			padding-left: 15px;
			margin-bottom: 10px;
			border: none;
			outline: none;
			width: 100%;
			max-width: 295px;
			height: 40px;
		}
		&__error {
			display: block;
			text-align: left;
			font-family: $lato;
			font-size: 12px;
			margin-bottom: 10px;
			color: darkred;
		}
		&__label {
			display: flex;
			align-items: center;
			position: relative;
			cursor: pointer;
			width: 100%;
			text-align: left;
			font-family: $lato;
			font-size: 12px;
			-webkit-user-select: none;
			-moz-user-select: none;
			-ms-user-select: none;
			user-select: none;
			margin-bottom: 15px;
			input {
				position: absolute;
				opacity: 0;
				cursor: pointer;
			}
			input:checked + .logIn__checkbox > .logIn__checkbox--bg {
				background-color: $black;
			}
		}
		&__checkbox {
			position: relative;
			height: 10px;
			width: 10px;
			border: 2px solid $black;
			margin-right: 5px;
			&--bg {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				display: block;
				width: 5px;
				height: 5px;
			}
		}
		&__btn {
			cursor: pointer;
			display: block;
			text-transform: uppercase;
			width: 100%;
			max-width: 295px;
			height: 50px;
			background-color: $black;
			color: #fff;
			font-family: $lato-bold;
			font-size: 16px;
			border: none;
			outline: none;
			text-decoration: none;
			letter-spacing: 0.05em;
			&--flex {
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 20px;
			}
		}
		&__or {
			margin: 15px 0;
			display: block;
			font-family: $lato-bold;
			font-size: 16px;
			text-transform: uppercase;
			line-height: 20px;
		}
		&__password {
			cursor: pointer;
			display: block;
			font-size: 12px;
			text-align: center;
			color: $black;
			text-decoration: none;
			&--cancel {
				margin-top: 20px;
			}
		}
	}

	@media (max-width: 991.98px) {
		.logIn {
			padding-top: 25px;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(243, 235, 212, .83);
			&__form {
				padding: 65px 15px 40px;
			}
			&__btn {
				margin: 0 auto 20px;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/LogInComponent.vue